import { render, staticRenderFns } from "./TableContractsGold.vue?vue&type=template&id=0f20f930"
import script from "./TableContractsGold.vue?vue&type=script&lang=js"
export * from "./TableContractsGold.vue?vue&type=script&lang=js"
import style0 from "./TableContractsGold.vue?vue&type=style&index=0&id=0f20f930&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports